import React, { useEffect, useState } from "react";
import {
  AddUser,
  DeleteUser,
  GetAdminUserProfile,
  PostAdminUserProfile,
} from "../../Services/UserProfile";
import Pagination from "@mui/material/Pagination";
import UserDatabaseSkeleton from "./UserDatabaseSkeleton";
import { MdVerified } from "react-icons/md";
import { FaHourglassHalf } from "react-icons/fa";
import { toast } from "react-toastify";
import AddUserModal from "./AddUser";
import { Button, IconButton, Skeleton } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { useMutation } from "react-query";

const UserDatabase = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);

  const { mutate: DeleteUserdata } = useMutation(DeleteUser, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        fetchUserProfile();
      } else {
        toast.warn(res?.data?.message);
      }
    },
  });

  const fetchUserProfile = async (page) => {
    try {
      setLoading(true);
      const res = await GetAdminUserProfile({ page, search: search });
      //   console.log(res?.data)
      setData(res?.data || []);
      setLoading(false);
    } catch (err) {
      throw new Error(err);
    }
  };
  useEffect(() => {
    fetchUserProfile();
  }, [search]);
  const handleChange = (e, value) => {
    setPage(value);
  };
  const handleVerifyProfile = async (id) => {
    try {
      const res = await PostAdminUserProfile({ user_profile_id: id });
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        await fetchUserProfile();
      } else {
        toast.warn(res?.data?.message);
      }
    } catch (err) {
      throw new Error(err);
    }
  };
  return (
    <div className="w-full">
      <div className=" mx-auto px-2 py-2">
        <p className="md:text-2xl text-lg font-bold text-black pb-2">
          Admin User Panel
        </p>
        <div className="py- flex  items-center  justify-between">
          <input
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            placeholder="Start typing to search users..."
            className=" border px-4 py-2 rounded-md"
          />
          <Button
            onClick={() => setOpen(true)}
            variant="contained"
            startIcon={<Add />}
          >
            User
          </Button>
        </div>

        {data?.data?.length > 0 ? (
          <>
            <div className="overflow-x-auto bg-white shadow-md rounded-lg border border-gray-200 mt-2">
              <table className="w-full text-sm text-left text-gray-700 ">
                <thead className="text-xs text-gray-500 uppercase bg-gray-50 border-b">
                  <tr>
                    <th className="px-4 py-2">Name</th>
                    <th className="px-4 py-2">Phone</th>
                    <th className="px-4 py-2">Email</th>
                    <th className="px-4 py-2">Status</th>

                    <th className="px-4 py-2">Role</th>
                    <th className="px-4 py-2">Action</th>
                    {/* <th className="px-4 py-3">Store</th> */}

                    {/* <th className="px-4 py-3">Username</th> */}
                  </tr>
                </thead>

                {loading ? (
                  <tbody>
                    {Array.from({ length: 5 }).map((_, idx) => (
                      <tr key={idx} className="border-b">
                        <td className="px-4 py-1">
                          <Skeleton variant="circular" width={48} height={48} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={100} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={80} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={120} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={60} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={40} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={70} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={70} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={80} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={150} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton variant="rounded" width={60} height={20} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={120} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={120} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={70} />
                        </td>
                        <td className="px-4 py-1">
                          <Skeleton width={80} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    {data?.data?.map((user) => (
                      <tr
                        key={user.id}
                        className="border-b hover:bg-gray-50 transition-all"
                      >
                        <td className="px-4 py-1 font-medium">
                          {user.first_name || user.last_name
                            ? `${user.first_name} ${user.last_name}`
                            : "—"}
                        </td>
                        <td className="px-4 py-1">{user.phone || "—"}</td>
                        <td className="px-4 py-1">{user.email || "—"}</td>
                        <td className="px-4 py-1">
                          {user?.status ? (
                            <div
                              onClick={() => handleVerifyProfile(user?.id)}
                              className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-600"
                            >
                              <MdVerified size={14} />
                              Verified
                            </div>
                          ) : (
                            <button
                              onClick={() => handleVerifyProfile(user?.id)}
                              className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-600 hover:bg-yellow-200 transition"
                            >
                              <FaHourglassHalf size={14} />
                              Verify Now
                            </button>
                          )}
                        </td>

                        <td className="px-4 py-1">{user.role || "—"}</td>

                        <td className="px-4 py-1">
                          <IconButton
                            onClick={() =>
                              DeleteUserdata({ user_id: user?.id })
                            }
                          >
                            <Delete color="error" />
                          </IconButton>
                        </td>
                        {/* <td className="px-4 py-3">{user.store || "—"}</td> */}

                        {/* <td className="px-4 py-3">{user.username || "—"}</td> */}
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>

            {/* <div className="flex items-center justify-center pt-2">
              <Pagination
                count={data?.count}
                page={page}
                onChange={handleChange}
                color="primary"
              />
            </div> */}
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-12">
            <img
              src="https://plus.unsplash.com/premium_photo-1739178656557-16b949fea186?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8bm8lMjB1c2VyJTIwcHJvZmlsZXxlbnwwfHwwfHx8MA%3D%3D"
              alt="No data"
              className="w-48 h-48 object-contain mb-4"
            />
            <p className="text-gray-500 text-center text-sm">No Users found.</p>
          </div>
        )}
      </div>

      <AddUserModal
        open={open}
        onClose={() => setOpen(false)}
        fetchUserProfile={fetchUserProfile}
      />
    </div>
  );
};

export default UserDatabase;
